import React, { useRef, useState, useEffect } from 'react'
import { Grid } from '@mui/material'
import { Loader, MuiSelect, MuiTextField, MuiButton, AccordionWithArrow, MuiDatePicker, Message } from '../../../components'
import forumService from '../../../services/forum.service'
import { ROUTE_SOCIAL_MONITOR, NAME_NEW_AGGREGATION } from '../../../constants'
import { useGlobalStore } from '../../../store'
import { consoleLog, defaultSelectObj, getObjectAsArray, getUserType } from '../../../util'

const Add = () => {
  const initialFormObj = {
    itemText: '',
    itemUrl: '',
    itemDate: '',
    itemDateSelected: '',
    itemTime: '00:00:00',
    itemTimeSelected: '00:00:00',
    itemDateTime: '',
    itemTranslation: '',
    itemQuestion2: '',
    itemQuestion4: '',
    itemQuestion8: '',
    aggregationItemFeatures: {
      AggregationItemFeature: [
        {
          AggregationItemId: '',
          PropertyName: 'Item Question 2',
          PropertyValue: ''
        },
        {
          AggregationItemId: '',
          PropertyName: 'Item Question 4',
          PropertyValue: ''
        },
        {
          AggregationItemId: '',
          PropertyName: 'Item Question 8',
          PropertyValue: ''
        }
      ]
    },
    userName: '',
    userUrl: '',
    keywordSearchTerm: '',
    sourceName: ''
  }

  const form = useRef()
  const [aggregation, setAggregation] = useState(initialFormObj)
  const [formSelectData, setFormSelectData] = useState()
  const [loader, setLoader] = useState(false)
  const [viewItemId, setViewItemId] = useState(null)
  const [messages, setMessages] = useState(null)
  const { company, user } = useGlobalStore()

  const onChangeHandler = (key, value) => {
    const obj = {
      ...aggregation,
      [key]: value || null
    }

    if (key === 'itemDate') {
      const m = (value.$M + 1) < 10 ? ('0' + (value.$M + 1)) : (value.$M + 1)
      const d = value.$D < 10 ? ('0' + value.$D) : (value.$D)
      obj.itemDateSelected = `${value.$y}-${m}-${d}`
      // obj.itemDateSelected = `${value.$y}-${value.$M + 1}-${value.$D}`
    }
    // if (key === 'itemTime') { obj.itemTimeSelected = `${value.$y}-${value.$M + 1}-${value.$D}` }

    setAggregation(obj)
  }

  const submitPayload = (e) => {
    e.preventDefault()
    if (!(
      aggregation?.itemText && aggregation?.itemUrl && aggregation?.itemDateSelected && aggregation?.itemTime &&
      aggregation?.userName && aggregation?.userUrl && aggregation?.keywordSearchTerm
    )) {
      setMessages({ type: 'error', msg: 'Please fill the form completely' })
      return false
    } else if (!(aggregation?.source) && getUserType(user).value === 0) {
      setMessages({ type: 'error', msg: 'Please fill the form completely' })
      return false
    }

    const dt = new Date()
    const m = (dt.getMonth() + 1) < 10 ? ('0' + (dt.getMonth() + 1)) : (dt.getMonth() + 1)
    const d = dt.getDate() < 10 ? ('0' + dt.getDate()) : (dt.getDate())
    const defaultDate = `${dt.getFullYear()}-${m}-${d}`
    const itemDateTimeFinal = aggregation?.itemDateSelected ? aggregation?.itemDateSelected + 'T' : defaultDate + 'T'

    const obj = {
      organizationId: company?.OrganizationId,
      itemText: encodeURIComponent(aggregation?.itemText) || null,
      itemUrl: aggregation?.itemUrl || null,
      // itemDate: aggregation?.itemDate || null,
      // itemTime: aggregation?.itemTime || null,
      itemDateTime: `${itemDateTimeFinal}${aggregation?.itemTime || '00:00:00'}` || null, // yyyy-MM-dd HH:mm:ss // 2025-5-22 15:30:00
      itemTranslation: aggregation?.itemTranslation || null,
      // aggregationItemFeatures: { AggregationItemFeature: [] },
      userName: aggregation?.userName || null,
      userUrl: aggregation?.userUrl || null,
      keywordSearchTerm: aggregation?.keywordSearchTerm || null,
      sourceName: aggregation?.source || null
    }

    if (
      aggregation.itemQuestion2.length > 0 || aggregation.itemQuestion4.length > 0 || aggregation.itemQuestion8.length > 0
    ) {
      obj.aggregationItemFeatures = { AggregationItemFeature: [] }
      // obj.aggregationItemFeatures.AggregationItemFeature.push({ AggregationItemId: '', PropertyName: '', PropertyValue: '' })
    }

    if (aggregation.itemQuestion2.length > 0) {
      obj.aggregationItemFeatures.AggregationItemFeature.push({ AggregationItemId: '00000000-0000-0000-0000-000000000000', PropertyName: 'Item Question 2', PropertyValue: aggregation.itemQuestion2 })
    }
    if (aggregation.itemQuestion4.length > 0) {
      obj.aggregationItemFeatures.AggregationItemFeature.push({ AggregationItemId: '00000000-0000-0000-0000-00000000', PropertyName: 'Item Question 4', PropertyValue: aggregation.itemQuestion4 })
    }
    if (aggregation.itemQuestion8.length > 0) {
      obj.aggregationItemFeatures.AggregationItemFeature.push({ AggregationItemId: '00000000-0000-0000-0000-00000000', PropertyName: 'Item Question 8', PropertyValue: aggregation.itemQuestion8 })
    }

    setLoader(true)
    setMessages({ type: 'success', msg: '' })
    // forumService.setBareBoneAggregationItemAndUserApi(obj)
    forumService.setBareBoneAggregationItemAndUserInOrganizationApi(obj)
      .then((resp) => {
        if (resp?.split('-').length === 5) {
          setTimeout(() => {
            setViewItemId(resp)
            setMessages({ type: 'success', msg: `New Item added. Id: ${resp}` })
            setLoader(false)
          }, 2500)
        } else {
          setMessages({ type: 'error', msg: 'Item not saved!' })
          setLoader(false)
        }
      })
      .catch((error) => {
        consoleLog('ERROR : ', error)
        setMessages({ type: 'error', msg: 'Item not saved!' })
        setLoader(false)
      })
  }

  const onLoad = async () => {
    const payload = { organizationId: company?.OrganizationId }
    setLoader(true)
    const keywordApi = await forumService.getOrganizationAggregationKeywordsApi(payload)
    const keywordArray = getObjectAsArray(keywordApi).map(d => ({ label: d.KeywordValue, value: d.KeywordValue, valKeywordValue: d.KeywordValue, valKeywordId: d.KeywordId, valKeywordSearchTerm: d.KeywordSearchTerm }))
    keywordArray.unshift(defaultSelectObj.empty)

    const question2Api = await forumService.getOrganizationAggregationSingleQuestionFuncApi(payload, 2)
    const question2Array = getObjectAsArray(question2Api).reduce((oldVal, newVal) => ([...oldVal, { label: newVal, value: newVal }]), [])
    question2Array.unshift(defaultSelectObj.empty)

    const question4Api = await forumService.getOrganizationAggregationSingleQuestionFuncApi(payload, 4)
    const question4Array = getObjectAsArray(question4Api).reduce((oldVal, newVal) => ([...oldVal, { label: newVal, value: newVal }]), [])
    question4Array.unshift(defaultSelectObj.empty)

    const sourceArray = [
      defaultSelectObj.empty,
      { label: 'Digg', value: 'Digg' },
      { label: 'Facebook', value: 'Facebook' },
      { label: 'FacebookGroup', value: 'FacebookGroup' },
      { label: 'Forums', value: 'Forums' },
      { label: 'Instagram', value: 'Instagram' },
      { label: 'Twitter', value: 'Twitter' },
      { label: 'YouTube', value: 'YouTube' },
      { label: 'YouTubeVideo', value: 'YouTubeVideo' }
    ]

    const allDataArray = { keyword: keywordArray, itemQuestion2: question2Array, itemQuestion4: question4Array, source: sourceArray }

    setFormSelectData(allDataArray)
    setLoader(false)
  }

  useEffect(() => {
    onLoad()
  }, [])

  useEffect(() => {
    setAggregation(initialFormObj)
  }, [])

  return (
    <>
      <AccordionWithArrow title={NAME_NEW_AGGREGATION} showArrow={false} accordionstyle='fieldset'>
        <form ref={form} onSubmit={submitPayload} autoComplete='on'>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <MuiTextField
                name='itemText'
                placeholder='Item Text'
                onChange={(e) => onChangeHandler('itemText', e.target.value)}
                variant='standard'
                value={aggregation?.itemText || ''}
                multiline
                minRows={3}
                maxRows={8}
              />
            </Grid>
            <Grid item xs={12}>
              <MuiTextField
                name='itemUrl'
                placeholder='Item Url'
                onChange={(e) => onChangeHandler('itemUrl', e.target.value)}
                variant='standard'
                value={aggregation?.itemUrl || ''}
              />
            </Grid>
            <Grid item xs={3}>
              <MuiDatePicker
                name='ItemDate'
                placeholder='Item Date (YYYY-MM-DD)'
                onChange={(e) => onChangeHandler('itemDate', e)}
                variant='standard'
                value={aggregation?.itemDate || ''}
                format='YYYY/MM/DD'
              />
            </Grid>
            <Grid item xs={3}>
              <MuiTextField
                name='ItemTime'
                placeholder='Item Time (HH:mm:ss)'
                onChange={(e) => onChangeHandler('itemTime', e.target.value)}
                variant='standard'
                value={aggregation?.itemTime || '00:00:00'}
              />
            </Grid>
            {getUserType(user).value === 0 &&
            <>
              <Grid item xs={12}>
                <MuiTextField
                  name='itemTranslation'
                  placeholder='Item Translation'
                  onChange={(e) => onChangeHandler('itemTranslation', e.target.value)}
                  variant='standard'
                  value={aggregation?.itemTranslation || ''}
                  multiline
                  minRows={3}
                  maxRows={8}
                />
              </Grid>
              <Grid item xs={3}>
                {formSelectData?.itemQuestion2?.length > 0 && <MuiSelect
                  data={formSelectData.itemQuestion2}
                  name='itemQuestion2'
                  placeholder='Item Question 2'
                  onChange={(e) => onChangeHandler('itemQuestion2', e.target.value)}
                  variant='standard'
                  value={aggregation?.itemQuestion2 || ''}
                />}
              </Grid>
              <Grid item xs={3}>
                {formSelectData?.itemQuestion4?.length > 0 && <MuiSelect
                  data={formSelectData.itemQuestion4}
                  name='itemQuestion4'
                  placeholder='Item Question 4'
                  onChange={(e) => onChangeHandler('itemQuestion4', e.target.value)}
                  variant='standard'
                  value={aggregation?.itemQuestion4 || ''}
                />}
              </Grid>
              <Grid item xs={3}>
                <MuiTextField
                  name='itemQuestion8'
                  placeholder='Item Question 8'
                  onChange={(e) => onChangeHandler('itemQuestion8', e.target.value)}
                  variant='standard'
                  value={aggregation?.itemQuestion8 || ''}
                />
              </Grid>
            </>}
            <Grid item xs={12} style={{ padding: 0 }}></Grid>
            <Grid item xs={3}>
              <MuiTextField
                name='userName'
                placeholder='User Name'
                onChange={(e) => onChangeHandler('userName', e.target.value)}
                variant='standard'
                value={aggregation?.userName || ''}
              />
            </Grid>
            <Grid item xs={3}>
              <MuiTextField
                name='userUrl'
                placeholder='User Url'
                onChange={(e) => onChangeHandler('userUrl', e.target.value)}
                variant='standard'
                value={aggregation?.userUrl || ''}
              />
            </Grid>
            <Grid item xs={12} style={{ padding: 0 }}></Grid>
            <Grid item xs={3}>
              {formSelectData?.keyword?.length > 0 && <MuiSelect
                data={formSelectData.keyword}
                name='keywordSearchTerm'
                placeholder='keyword'
                onChange={(e) => onChangeHandler('keywordSearchTerm', e.target.value)}
                variant='standard'
                value={aggregation?.keywordSearchTerm || ''}
              />}
            </Grid>
            {getUserType(user).value === 0 && formSelectData?.source?.length > 0 &&
              <Grid item xs={3}>
                <MuiSelect
                  data={formSelectData.source}
                  name='source'
                  placeholder='Source'
                  onChange={(e) => onChangeHandler('source', e.target.value)}
                  variant='standard'
                  value={aggregation?.source || ''}
                />
              </Grid>
            }
            <Grid item xs={12}></Grid>
            <Grid item xs={12}>
              <MuiButton
                onClick={submitPayload}
                type='submit'
                color='primary'
                variant='contained'
                style={{ width: '120px' }}
                disabled={loader}
              >
                Submit
              </MuiButton>
              <MuiButton
                onClick={() => { setAggregation(initialFormObj); setMessages(null) }}
                type='button'
                color='secondary'
                variant='contained'
                style={{ width: '120px', margin: '0 8px' }}
                disabled={loader}
              >
                Refresh
              </MuiButton>
              {viewItemId && <MuiButton
                onClick={() => consoleLog('EditItem > ', viewItemId)}
                type='button'
                color='secondary'
                variant='contained'
                style={{ width: '120px' }}
                disabled={loader}
                // to={`${ROUTE_SOCIAL_MONITOR}?selectedTab=All&id=${viewItemId}&startIndex=1`} // /social-monitor?selectedTab=All&id=1a941591-fcf3-11ec-bca4-0a1ea4c5532f&startIndex=1
                to={`${ROUTE_SOCIAL_MONITOR}?selectedTab=All&id=${viewItemId}&startIndex=1&aggregationItemId=${viewItemId}`} // http://localhost:7000/social-monitor?selectedTab=All&id=1a941591-fcf3-11ec-bca4-0a1ea4c5532f&startIndex=1&aggregationItemId=1a941591-fcf3-11ec-bca4-0a1ea4c5532f
              >
                View Item
              </MuiButton>}
              <Message align='left' type={messages?.type}>{messages?.msg || ''}</Message>
            </Grid>
          </Grid>
          {loader && <Loader />}
        </form>
      </AccordionWithArrow>
    </>
  )
}

export default Add
